
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index39a8OSFGC2wGUqrpGvCuyA5RDwhn33XcEalVaAEhFLoMeta } from "/app/pages/cometa/index.vue?macro=true";
import { default as Recoverj7Vp5DuKs2xXNS9rgci78mMZbGrswBzBq_i_f3_45VPXcMeta } from "/app/pages/cometa/Recover.vue?macro=true";
import { default as _91id_930T66mQr7K2VrFboDsc5Tb9rs4Ty5UNXHDaM7Jv9GuaQMeta } from "/app/pages/cometa/ref/[id].vue?macro=true";
import { default as _91id_932DkkuiX9SS9Im7IxmPu9h02SEpPfsM2xWEEFVTVYP_45UMeta } from "/app/pages/cometa/play/[id].vue?macro=true";
import { default as indexS_45Dm9tHTgcfxUa0SOPS39jGTGt0zgtQI1TAHZ7SUi8oMeta } from "/app/pages/cometa/home/index.vue?macro=true";
import { default as liveWJ5hBaQyl3GRV_453ZJfpZnNyEk4m6Z91wRC0pp8QVBzkMeta } from "/app/pages/cometa/casino/live.vue?macro=true";
import { default as minesr3aftDYi1_456fIYTT3IOazi73mpuk8RfWtuC22k1d1H8Meta } from "/app/pages/cometa/games/mines.vue?macro=true";
import { default as _91regulation_93MQE5JLOlRUJhkT487rSNZ42aaRIeeJrrJT8hwFwkvWYMeta } from "/app/pages/cometa/[regulation].vue?macro=true";
import { default as indexfqAPUA72a1ooUYrzHeCN8PP9lN7pfJqSZ_CijJ36IasMeta } from "/app/pages/cometa/casino/index.vue?macro=true";
import { default as slots2dlxvvymgdN3atZwQZXr9ubV3m9k0x3ecPSnhca_45cDYMeta } from "/app/pages/cometa/casino/slots.vue?macro=true";
import { default as doubleewDErSBJV8_XzbBXFDoI_459D1043rGV873_5QURRQA1YMeta } from "/app/pages/cometa/games/double.vue?macro=true";
import { default as _91id_93QNAeSVhPzRTTrVZtMhPnaykCL4GQHbyB4Xb_45ITtClikMeta } from "/app/pages/cometa/providers/[id].vue?macro=true";
import { default as _91id_93M8Gr_7Zgvq3r28FDoH0i0hPcK6tOVAc5lVOmjAjRKM4Meta } from "/app/pages/cometa/promotions/[id].vue?macro=true";
import { default as indexIkyPQnIPniZJu1ijkHcs85zwFH6JOsVPqCH8kUwcOzoMeta } from "/app/pages/cometa/providers/index.vue?macro=true";
import { default as recuperar_45senhaJWZ8SzfYIe9FI_PnC8cR_45Fel0npwPDLBOJ3MDe27QSsMeta } from "/app/pages/cometa/recuperar-senha.vue?macro=true";
import { default as indexPkfP_45_45qKBoiZAWmXGiqGSK7cMb_XdImHTxQdQlhHoCYMeta } from "/app/pages/cometa/suppliers/index.vue?macro=true";
import { default as favoritesX70VczbI43_5A1EUHJIsjzw1hL3PIrU8BjTTsktp7fgMeta } from "/app/pages/cometa/casino/favorites.vue?macro=true";
import { default as index8_45ISJTzf88NQrAXY8qLnbI6ihXu6tSDLv9ehDM3lYegMeta } from "/app/pages/cometa/promotions/index.vue?macro=true";
import { default as _91_46_46_46page_93v9_45BU2RZB_45XuL5ZMtjCxum4NXRswYhp0Df5VZFzLcEAMeta } from "/app/pages/cometa/sports/[...page].vue?macro=true";
import { default as indexeojFjJvEbJljnhelJcqJZeygcNPz1L_xNOmFhV4pl08Meta } from "/app/pages/cometa/user/wallet/index.vue?macro=true";
import { default as indexyZ4xROwalLemzM2I1psxp4Vd5_AGNX3t5HYS_iDEk4IMeta } from "/app/pages/cometa/user/account/index.vue?macro=true";
import { default as indexJ5BLuXCxvDVqC8sNdpLR6Bf1OPy81xCQNsSj4YyrxT4Meta } from "/app/pages/cometa/rules-betting/index.vue?macro=true";
import { default as index8fDad6I_lr3o4AnH_OPySDmk8N4AfH_EJeoRjCju2ZAMeta } from "/app/pages/cometa/user/password/index.vue?macro=true";
import { default as indexnxri18pz5yni3OuMUNhB_45pqch3waEjQvd__6h9HKm4kMeta } from "/app/pages/cometa/user/withdraw/index.vue?macro=true";
import { default as indexNpKjeqtwwSlfsYef0TXj6Ow9_45maL1AZFUSLX0xjU_45FMMeta } from "/app/pages/cometa/user/promotion/index.vue?macro=true";
import { default as _91categoryName_93xgZUPYkm4_45Q5dLSY326iX5WpP0wVBbZYxyAhx_45zre_wMeta } from "/app/pages/cometa/casino/[categoryName].vue?macro=true";
import { default as index7VJ96Eadb0Zz3NAgzDK1Uen1U0pa1_oQJSQjRqI6KmsMeta } from "/app/pages/cometa/user/protection/index.vue?macro=true";
import { default as indexEORcT_458E8thB31GPoIClthHXWV1ouIODzbyZ7ChLATQMeta } from "/app/pages/cometa/user/indications/index.vue?macro=true";
import { default as indexSIyKiCLsKfaPSocVOnms9BHUO4eRIPjXS2ftHybR4t4Meta } from "/app/pages/cometa/user/transaction/index.vue?macro=true";
import { default as _91_46_46_46page_934RboChtqpR0Yg1ifqfuTDNxNAJ_45gdiCRAzlIJYjwCDoMeta } from "/app/pages/cometa/altenar-sports/[...page].vue?macro=true";
import { default as _91_46_46_46page_93ozvYWdQY1hDJKbIB5YNgKUe4DEvkhJwagPdEnN0TNKgMeta } from "/app/pages/cometa/sports/esports/[...page].vue?macro=true";
import { default as indexkYnsjndXycoSgrfiqlNON_450w8YfXeF_3JblczBoUwjoMeta } from "/app/pages/cometa/user/wallet/deposit/index.vue?macro=true";
import { default as indexUp7BxCSjRCJvG33EemcG6GJDGR_45ArSZGZwsNUt4rIs8Meta } from "/app/pages/cometa/user/wallet/withdraw/index.vue?macro=true";
import { default as index_OVfLKsgqxZntb_453nOev3zEvLqFAWT02_45R9gDam_45ajYMeta } from "/app/pages/cometa/user/account/document/index.vue?macro=true";
import { default as indexb_45PX9cIHzTwjkvwYNXuFZzXPaoHTlK_45fa6LbPT9ioI8Meta } from "/app/pages/cometa/user/account/password/index.vue?macro=true";
import { default as indexoo1jUTezmL9lBtqkSViiqgKaWO0mILXSz2g1F3vwLZEMeta } from "/app/pages/cometa/user/promotion/coupon/index.vue?macro=true";
import { default as index3HCDXZrzos7KKVqb_45UJ_T4UuHh9ngsTghnG9sAUCwSgMeta } from "/app/pages/cometa/user/protection/exclusion/index.vue?macro=true";
import { default as indexLW6ddW5325cYIMWavqjzlrwkBEKP_GSZJTTnbUw7WtMMeta } from "/app/pages/cometa/user/protection/suspension/index.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/cometa/index.vue")
  },
  {
    name: "Recover",
    path: "/Recover",
    component: () => import("/app/pages/cometa/Recover.vue")
  },
  {
    name: "ref-id",
    path: "/ref/:id()",
    component: () => import("/app/pages/cometa/ref/[id].vue")
  },
  {
    name: "play-id",
    path: "/play/:id()",
    meta: {"middleware":["require-verification","cookie-consent"]},
    component: () => import("/app/pages/cometa/play/[id].vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/app/pages/cometa/home/index.vue")
  },
  {
    name: "casino-live",
    path: "/casino/live",
    component: () => import("/app/pages/cometa/casino/live.vue")
  },
  {
    name: "games-mines",
    path: "/games/mines",
    component: () => import("/app/pages/cometa/games/mines.vue")
  },
  {
    name: "regulation",
    path: "/:regulation()",
    component: () => import("/app/pages/cometa/[regulation].vue")
  },
  {
    name: "casino",
    path: "/casino",
    component: () => import("/app/pages/cometa/casino/index.vue")
  },
  {
    name: "casino-slots",
    path: "/casino/slots",
    component: () => import("/app/pages/cometa/casino/slots.vue")
  },
  {
    name: "games-double",
    path: "/games/double",
    component: () => import("/app/pages/cometa/games/double.vue")
  },
  {
    name: "providers-id",
    path: "/providers/:id()",
    component: () => import("/app/pages/cometa/providers/[id].vue")
  },
  {
    name: "promotions-id",
    path: "/promotions/:id()",
    component: () => import("/app/pages/cometa/promotions/[id].vue")
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/app/pages/cometa/providers/index.vue")
  },
  {
    name: "recuperar-senha",
    path: "/recuperar-senha",
    component: () => import("/app/pages/cometa/recuperar-senha.vue")
  },
  {
    name: "suppliers",
    path: "/suppliers",
    component: () => import("/app/pages/cometa/suppliers/index.vue")
  },
  {
    name: "casino-favorites",
    path: "/casino/favorites",
    component: () => import("/app/pages/cometa/casino/favorites.vue")
  },
  {
    name: "promotions",
    path: "/promotions",
    component: () => import("/app/pages/cometa/promotions/index.vue")
  },
  {
    name: "sports-page",
    path: "/sports/:page(.*)*",
    meta: { ...(_91_46_46_46page_93v9_45BU2RZB_45XuL5ZMtjCxum4NXRswYhp0Df5VZFzLcEAMeta || {}), ...{"middleware":["refresh-ip","require-verification","cookie-consent"]} },
    component: () => import("/app/pages/cometa/sports/[...page].vue")
  },
  {
    name: "user-wallet",
    path: "/user/wallet",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/cometa/user/wallet/index.vue")
  },
  {
    name: "user-account",
    path: "/user/account",
    meta: {"middleware":["auth","refresh-ip"]},
    component: () => import("/app/pages/cometa/user/account/index.vue")
  },
  {
    name: "rules-betting",
    path: "/rules-betting",
    component: () => import("/app/pages/cometa/rules-betting/index.vue")
  },
  {
    name: "user-password",
    path: "/user/password",
    meta: {"middleware":["auth","refresh-ip"]},
    component: () => import("/app/pages/cometa/user/password/index.vue")
  },
  {
    name: "user-withdraw",
    path: "/user/withdraw",
    meta: {"middleware":["auth","refresh-ip"]},
    component: () => import("/app/pages/cometa/user/withdraw/index.vue")
  },
  {
    name: "user-promotion",
    path: "/user/promotion",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/cometa/user/promotion/index.vue")
  },
  {
    name: "casino-categoryName",
    path: "/casino/:categoryName()",
    component: () => import("/app/pages/cometa/casino/[categoryName].vue")
  },
  {
    name: "user-protection",
    path: "/user/protection",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/cometa/user/protection/index.vue")
  },
  {
    name: "user-indications",
    path: "/user/indications",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/cometa/user/indications/index.vue")
  },
  {
    name: "user-transaction",
    path: "/user/transaction",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/cometa/user/transaction/index.vue")
  },
  {
    name: "altenar-sports-page",
    path: "/altenar-sports/:page(.*)*",
    component: () => import("/app/pages/cometa/altenar-sports/[...page].vue")
  },
  {
    name: "sports-esports-page",
    path: "/sports/esports/:page(.*)*",
    meta: {"middleware":["refresh-ip"]},
    component: () => import("/app/pages/cometa/sports/esports/[...page].vue")
  },
  {
    name: "user-wallet-deposit",
    path: "/user/wallet/deposit",
    meta: {"middleware":["auth","refresh-ip"]},
    component: () => import("/app/pages/cometa/user/wallet/deposit/index.vue")
  },
  {
    name: "user-wallet-withdraw",
    path: "/user/wallet/withdraw",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/cometa/user/wallet/withdraw/index.vue")
  },
  {
    name: "user-account-document",
    path: "/user/account/document",
    component: () => import("/app/pages/cometa/user/account/document/index.vue")
  },
  {
    name: "user-account-password",
    path: "/user/account/password",
    meta: {"middleware":["auth","refresh-ip"]},
    component: () => import("/app/pages/cometa/user/account/password/index.vue")
  },
  {
    name: "user-promotion-coupon",
    path: "/user/promotion/coupon",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/cometa/user/promotion/coupon/index.vue")
  },
  {
    name: "user-protection-exclusion",
    path: "/user/protection/exclusion",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/cometa/user/protection/exclusion/index.vue")
  },
  {
    name: "user-protection-suspension",
    path: "/user/protection/suspension",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/cometa/user/protection/suspension/index.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/sport/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/user/bonus",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/user/coupon",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]